'use strict'

const SELECTORS = {
    element: '.experience-App_Login',
    closeBtn: '.js-close-app-login'
}

const STORAGE = {
    key: 'appLoginDismissed_v1',
    ttl: 7 * 24 * 60 * 60 * 1000
}

class AppLogin {
    constructor(element) {
        this.element = element;
        this.closeBtn = element.find(SELECTORS.closeBtn);

        if (this.isDismissed()) {
            this.element.hide();
            return;
        }

        this.element.fadeIn(220);
        this.initEvents();
    }

    initEvents() {
        this.closeEvent();
    }

    closeEvent() {
        this.closeBtn
            .off('click.appLogin')
            .on('click.appLogin', (e) => {
                e.preventDefault();
                this.setDismissed();
                this.element.fadeOut(220);
            });
    }

    isDismissed() {
        try {
            const raw = window.localStorage.getItem(STORAGE.key);
            if (!raw) return false;

            const data = JSON.parse(raw);
            if (!data || typeof data.ts !== 'number') return false;

            return (Date.now() - data.ts) < STORAGE.ttl;
        } catch (e) {
            return false;
        }
    }

    setDismissed() {
        try {
            window.localStorage.setItem(
                STORAGE.key,
                JSON.stringify({ ts: Date.now() })
            );
        } catch (e) {}
    }
}

module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new AppLogin($(element));
    });
}
